import './App.css'

function App() {
  return (
    <div className="app">
      <video className="background-video" autoPlay muted>
        <source src="/bg.mp4" type="video/mp4" />
      </video>
      <div className="logo-container">
        <img src="/transparent_logomark_white.png" alt="Logo" className="center-logo" />
        <div className="social-links">
          <a href="https://www.linkedin.com/in/vladimir-tsachev-2b7796139/" target="_blank" rel="noopener noreferrer" className="social-link">
            LinkedIn
          </a>
          <a href="mailto:info@tsachev.eu" className="social-link">
            Email
          </a>
            <a href="https://tangramholo.com" className="social-link">
            TangramHOLO
          </a>

          <a href="https://github.com/vla-dun" target="_blank" rel="noopener noreferrer" className="social-link">
            GitHub
          </a>
        </div>
      </div>
    </div>
  )
}

export default App
